<div class="custom-modal-layout">
  <div class="modal-header" style="margin-bottom: 5px !important;">
    <div class="icon">
      <img src="icons/plus-circle.svg" alt="Email Icon" />
    </div>
    <span class="title">Editar representante</span>
    <p-button icon="pi pi-times" class="close-btn" [rounded]="true" [text]="true" (onClick)="cancel()"></p-button>
  </div>

  <form [formGroup]="representacaoForm" (ngSubmit)="onSubmit()" class="add-represent-form">
    <div class="p-fluid grid">

      <div class="field col-12">
        <div class="file-upload">
          <p-fileupload name="myfile[]" (onSelect)="onSelectedFiles($event)" [multiple]="false"
            accept="image/png, image/jpeg, image/jpg" maxFileSize="2000000000" invalidFileTypeMessageSummary="danger"
            invalidFileTypeMessageDetail="O Ficheiro seleccionado é inválido" invalidFileLimitMessageSummary="danger"
            invalidFileLimitMessageDetail="Ficheiro muito grande. Min: 2MB">
            <ng-template #header let-files let-chooseCallback="chooseCallback" let-clearCallback="clearCallback"
              let-uploadCallback="uploadCallback">
            </ng-template>
            <ng-template #content let-files let-uploadedFiles="uploadedFiles"
              let-removeFileCallback="removeFileCallback" let-chooseCallback="chooseCallback"
              let-removeUploadedFileCallback="removeUploadedFileCallback">
              <a class="circular-upload preview"
                [ngStyle]="{ 'background-image': imagePreview ? 'url(' + imagePreview + ')' : 'none' }">
                <span *ngIf="!imagePreview">Foto</span>
                <div class="icon" (click)="choose($event, chooseCallback)">
                  <img src="icons/camera-01.svg" alt="">
                </div>
              </a>
              <!-- <button pButton type="button" label="Guardar Foto" class="p-button-primary mt-2" (click)="savePhoto()"></button> -->
            </ng-template>
            <ng-template #file></ng-template>
            <ng-template #empty></ng-template>
          </p-fileupload>
        </div>
      </div>
      <div class="field col-6">
        <label for="nacinalidade">Nacionalidade <span class="text-red-500">*</span></label>
        <p-select id="nacinalidade" [filter]="true" formControlName="NacionalidadeEnum" class="w-full"
          [options]="nacionalidades" optionLabel="designacao" optionValue="id"
          placeholder="Seleccione a nacionalidade" />
      </div>

      <div class="field col-6">
        <label for="Bi">Número Bilhete de Identidade*</label>
        <div class="flex align-items-center relative">
          <input id="Bi" type="search" class="w-full" pInputText formControlName="Bi"
            placeholder="Informe o número do Bi" />
          <button pButton type="button" icon="pi pi-search" class="search-btn" *ngIf="isInternalInstitution"
            [disabled]="representacaoForm.get('Bi')?.invalid" (click)="searchDocumentNumber()"
            aria-label="Search"></button>
        </div>
        <div *ngIf="representacaoForm.get('Bi')?.touched && representacaoForm.get('Bi')?.invalid">
          <small class="error-message" *ngIf="representacaoForm.get('Bi')?.errors?.['required']">Número
            Bilhete de Identidade é obrigatório.</small>
        </div>
      </div>

      <div class="field col-6">
        <label for="nome">Nome <span class="text-red-500">*</span></label>
        <input id="nome" type="text" class="w-full" pInputText formControlName="nomeRepresentante"
          placeholder="Digite o nome" />
        <div *ngIf="representacaoForm.get('nome')?.invalid && representacaoForm.get('nome')?.touched"
          class="error-message">
          Nome é obrigatório
        </div>
      </div>

      <div class="field col-6 d-flex flex-column">
        <label for="telefone1">Telefone <span class="text-red-500">*</span></label>
        <ng-container *ngIf="isInternalInstitution; else foreignPhone" class="w-full col-6">
          <p-inputmask class="w-full" id="telemovelRequerente" mask="+244 999 999 999"
            formControlName="telefoneRepresentante" placeholder="+244 999 999 000" />
        </ng-container>
        <ng-template #foreignPhone>
          <input id="contacto" type="text" class="w-full" pInputText formControlName="telefoneRepresentante"
            placeholder="Digite o telefone com código do país" />
        </ng-template>
        <!-- <input id="contacto" type="text" class="w-full" pInputText formControlName="telefoneRepresentante" /> -->
        <div *ngIf="representacaoForm.get('telefone')?.invalid && representacaoForm.get('telefone')?.touched"
          class="error-message">
          Telefone é obrigatório e deve conter apenas números
        </div>
      </div>

      <div class="field col-6">
        <label for="email">Email <span class="text-red-500">*</span></label>
        <input id="email" type="email" class="w-full" pInputText formControlName="emailRepresentante"
          placeholder="Digite o email" />
        <div
          *ngIf="representacaoForm.get('emailRepresentante')?.invalid && representacaoForm.get('emailRepresentante')?.touched"
          class="error-message">
          Email é obrigatório e deve ser válido
        </div>
      </div>

      <div class="field col-6">
        <label for="tipoRepresentacao">Tipo de representação</label>
        <p-select [filter]="true" appendTo="body" id="tipoRepresentacao" class="w-full" optionLabel="designacao"
          optionValue="id" [options]="tiposRepresentacao" placeholder="Seleccione o tipo de representação"
          formControlName="tipoRepresentacaoID" />
        <div
          *ngIf="representacaoForm.get('tipoRepresentacaoID')?.invalid && representacaoForm.get('tipoRepresentacaoID')?.touched"
          class="error-message">
          Tipo de representação é obrigatório
        </div>
      </div>
    </div>

    <div class="modal-footer" style="margin-top: -10px !important;">
      <button pButton type="button" label="Cancelar" class="p-button-outlined" (click)="cancel()"></button>
      <button pButton type="submit" label="Editar Representante" class="p-button-primary"></button>
    </div>
  </form>

</div>
<p-toast></p-toast>